import { PageBlock } from '@design-system/page-block';
import { DangerouslySetInnerHtml } from '@phx-husky/dangerously-set-inner-html';
import React, { forwardRef } from 'react';

import { HtmlRTEBlockProps } from './models';

const HtmlRTEBlock = forwardRef<HTMLDivElement, HtmlRTEBlockProps>(
  ({ pageBlockUI, componentId, rte }, ref) => (
    <PageBlock {...pageBlockUI} id={componentId} className="json-rte-block" ref={ref}>
      <DangerouslySetInnerHtml className="cds-json-rte" html={rte} />
    </PageBlock>
  )
);

export default HtmlRTEBlock;
